document.addEventListener('DOMContentLoaded', async () => {
  const container = document.getElementById('simulation');
  const output = document.getElementById('output');
  const carousel = document.getElementById('carousel');

  // Debug logs
  let debugLog = [];
  function debugPrint(msg) {
    debugLog.push(msg);
    if (output) {
      output.innerHTML = debugLog.join('<br>');
      output.scrollTop = output.scrollHeight; // Scroll to the latest message
    }
  }

  // Fetch products from the Shopify storefront
  async function fetchProducts() {
    debugPrint('Fetching products...');
    const response = await fetch('/products.json');
    if (!response.ok) {
      debugPrint(`Error fetching products: ${response.statusText}`);
      return [];
    }
    const data = await response.json();
    debugPrint(`Loaded ${data.products.length} products.`);
    return data.products;
  }

  // Initialize the simulation
  async function initSimulation() {
    debugPrint('Initializing simulation...');

    const products = await fetchProducts();
    if (products.length === 0) return;

    const scene = new THREE.Scene();
    scene.background = new THREE.Color('#FFFFFF');

    const camera = new THREE.PerspectiveCamera(75, container.offsetWidth / container.offsetHeight, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setSize(container.offsetWidth, container.offsetHeight);
    container.appendChild(renderer.domElement);

    // Product display in the carousel
    products.slice(0, 10).forEach(product => {
      const productCard = document.createElement('div');
      productCard.textContent = product.title;
      carousel.appendChild(productCard);
    });

    const geometry = new THREE.SphereGeometry(5, 16, 16);
    const material = new THREE.MeshBasicMaterial({ color: '#404040' });

    const objects = [];
    products.forEach(() => {
      const sphere = new THREE.Mesh(geometry, material);
      sphere.position.set(
        Math.random() * 700 - 350,
        Math.random() * 600 - 300,
        Math.random() * 400 - 200
      );
      scene.add(sphere);
      objects.push(sphere);
    });

    camera.position.z = 500;

    function animate() {
      requestAnimationFrame(animate);
      objects.forEach(obj => {
        obj.rotation.x += 0.01;
        obj.rotation.y += 0.01;
      });
      renderer.render(scene, camera);
    }

    animate();
  }

  // Start simulation
  initSimulation();
});
